import { jsx as _jsx } from "react/jsx-runtime";
import { CssBaseline, ThemeProvider } from '@mui/material';
import { fontTheme } from './themes';
/**
 * IMPORTANT - All helix components must be put inside the HelixApp element in order to properly style MUI components.
 */
export const HelixApp = ({ children }) => {
    return (_jsx(ThemeProvider, Object.assign({ theme: fontTheme }, { children: _jsx(CssBaseline, { children: children }) })));
};
export default HelixApp;
